<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item"><a [routerLink]="parkId ? ['/smart-irrigation/parks', parkId] : ['/smart-irrigation/parks']">{{ parkName || 'Parks' }}</a></li>
      <li class="breadcrumb-item"><a (click)="goBack()" style="cursor:pointer">Site Dashboard</a></li>
      <li class="breadcrumb-item active">
        <div class="btn-group form-group-sm" dropdown>
          <a dropdownToggle class="link" style="cursor:pointer">
            <strong>{{ paramName }}</strong>
            <i class="fa fa-sort-asc"></i>
          </a>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="menuitem" *ngFor="let probeOption of soilMoistureProbes">
              <a class="dropdown-item" [class.fw-bold]="probeOption.siteUri === siteUri"
                 (click)="navigateToSensor(probeOption)">
                {{ probeOption.description || probeOption.name || probeOption.deviceEui }}
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="findUriAndLoad()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">

  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading sensor data&hellip;
  </div>

  <div class="alert alert-warning" *ngIf="!loading && noData">
    No sensor data found for this probe.
    <a (click)="goBack()" style="cursor:pointer" class="alert-link">Go back</a>
  </div>

  <ng-container *ngIf="!loading && !noData">

    <div class="st-summary">
      <div class="st-metric-card"
           [ngClass]="moistureCurrent !== '--' && +moistureCurrent < 15 ? 'st-metric-card--red' : moistureCurrent !== '--' && +moistureCurrent < 20 ? 'st-metric-card--amber' : 'st-metric-card--green'">
        <div class="st-metric-card__label">Current Moisture</div>
        <div class="st-metric-card__value">{{ moistureCurrent }}<span class="st-metric-card__unit">% VMC</span></div>
        <div class="st-metric-card__sub">{{ +moistureCurrent < 15 ? 'ALERT' : +moistureCurrent < 20 ? 'WARNING' : 'NORMAL' }}</div>
      </div>
      <div class="st-metric-card">
        <div class="st-metric-card__label">14-Day Range</div>
        <div class="st-metric-card__value st-metric-card__value--sm">{{ moistureRange }}</div>
        <div class="st-metric-card__sub">% VMC</div>
      </div>
      <div class="st-metric-card">
        <div class="st-metric-card__label">14-Day Change</div>
        <div class="st-metric-card__value st-metric-card__value--sm"
             [ngClass]="moistureChange.startsWith('-') ? 'st-metric-card__value--red' : 'st-metric-card__value--green'">
          {{ moistureChange }}
        </div>
        <div class="st-metric-card__sub">% VMC</div>
      </div>
    </div>

    <div class="st-trend-note" *ngIf="overallTrendNote"
         [ngClass]="overallTrend === 'Declining' ? 'st-trend-note--red' : overallTrend === 'Improving' ? 'st-trend-note--green' : 'st-trend-note--muted'">
      {{ overallTrendNote }}
    </div>

    <div class="st-chart-card">
      <div class="st-chart-card__header">
        <div class="st-chart-card__title">Soil Moisture &#8212; 14-Day History</div>
        <button type="button" class="btn btn-outline-light btn-sm st-chart-card__edit"
          (click)="openScheduleEditor()" [disabled]="scheduleLoading"
          title="Edit automated schedule" aria-label="Edit automated schedule">
          <i class="fa fa-pencil"></i>
        </button>
      </div>
      <highcharts-chart
        [Highcharts]="Highcharts"
        [constructorType]="chartConstructor"
        [options]="moistureChartOptions"
        style="width:100%;height:300px;display:block;">
      </highcharts-chart>
      <div class="st-chart-card__legend">
        <span class="st-chart-legend st-chart-legend--red">&#9472; Do Not Irrigate (scheduled)</span>
      </div>
    </div>

    <div class="st-trend-note st-trend-note--muted" *ngIf="noSchedule">
      No thresholds are configured for this controller schedule.
    </div>

    <div class="st-chart-card" *ngIf="temperatureChartOptions">
      <div class="st-chart-card__title">Temperature &#8212; 14-Day History</div>
      <highcharts-chart
        [Highcharts]="Highcharts"
        [constructorType]="chartConstructor"
        [options]="temperatureChartOptions"
        style="width:100%;height:300px;display:block;">
      </highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="conductivityChartOptions">
      <div class="st-chart-card__title">Conductivity (EC) &#8212; 14-Day History</div>
      <highcharts-chart
        [Highcharts]="Highcharts"
        [constructorType]="chartConstructor"
        [options]="conductivityChartOptions"
        style="width:100%;height:300px;display:block;">
      </highcharts-chart>
    </div>

    <div class="st-section-title">Daily Average Readings</div>
    <div class="st-table-wrap">
      <table class="st-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Moisture (% VMC)</th>
            <th>Temperature</th>
            <th>EC</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of dailyReadings" [ngClass]="'st-row--' + row.status">
            <td>{{ row.date }}</td>
            <td>{{ row.moisture != null ? (row.moisture | number:'1.1-1') : '&#8212;' }}</td>
            <td [ngClass]="row.temperature == null ? 'st-cell--muted' : 'st-cell--' + getTemperatureStatus(row.temperature)">{{ row.temperature != null ? (row.temperature | number:'1.1-1') : 'N/A' }}{{ row.temperature != null ? ' °C' : '' }}</td>
            <td [ngClass]="row.conductivity == null ? 'st-cell--muted' : 'st-cell--' + getConductivityStatus(row.conductivity)">{{ row.conductivity != null ? (row.conductivity | number:'1.1-1') : 'N/A' }}{{ row.conductivity != null ? ' µS/cm' : '' }}</td>
            <td><span class="st-badge" [ngClass]="'st-badge--' + row.status">{{ row.status | uppercase }}</span></td>
          </tr>
          <tr *ngIf="dailyReadings.length === 0">
            <td colspan="5" class="st-cell--muted" style="text-align:center">No daily readings available.</td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

</div>

<div class="modal fade" bsModal #scheduleModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="scheduleModalTitle">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="scheduleModalTitle">Edit Automated Schedule</h5>
        <button type="button" class="btn-close" (click)="scheduleModal.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <app-automated-schedule-editor [schedules]="automatedSchedules" 
                (scheduleChange)="onScheduleChange($event)"
                (scheduleAdd)="onScheduleAdd($event)"
          (scheduleDelete)="onScheduleDelete($event)"
          (clearSchedules)="onClearSchedules()"></app-automated-schedule-editor>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="scheduleModal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>